import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0312 from "../lesson-12/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "b3a5b350-b4f2-470e-9eb2-779b190076ce",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0312),
    lesson: lesson0312,
  },
];

export default lessonLinks;
